// extracted by mini-css-extract-plugin
export var redoItem = "_om-1";
export var redoTrigger = "_om-0";